import {useCallback, useState} from "react";
import {
  RankingGet,
  RankingAdd,
  RankingAddCampana,
  RankingCampanaGet,
  SeccionGet,
  SeccionesGet
} from "../services/ranking";

export default function useCategorias() {
  const [Posicion, setPosicion] = useState([]);
  const [Lugar, setLugar] = useState([]);
  const [Lugares, setLugares] = useState([]);
  const [Seccion, setSeccion] = useState([]);
  const [Posiciones, setPosiciones] = useState([]);
  const [State, setState] = useState({
    loading: false,
    error: false,
    message: "",
    success: false,
    successs: false,
  });

  const RankingGetService = useCallback((token, Roles) => {
    RankingGet(token, Roles).then((response) => {
      setPosicion(Object.values(response));
    });
  }, []);

  const SeccionGetService = useCallback((token, Dealer) => {
    SeccionGet(token, Dealer).then((response) => {
      setLugar(Object.values(response.data));
      setSeccion(response.seccion)
    });
  }, []);

  const SeccionesGetService = useCallback((token, Dealer) => {
    SeccionesGet(token, Dealer).then((response) => {
      setLugares(Object.values(response));
    });
  }, []);

  const RankingAddService = useCallback((data, token) => {
    setState({
      loading: true,
      error: false,
      message: "",
      success: false,
    });
    RankingAdd(data, token).then((response) => {
      setState({
        loading: false,
        error: false,
        message: "Busqueda realizada con exito",
        success: true,
      });
      setPosicion(response);
    });
  }, []);

  const RankingCampanaGetGetService = useCallback((token) => {
    RankingCampanaGet(token).then((response) => {
      setPosiciones(Object.values(response));
    });
  }, []);

  const RankingAddCampanaService = useCallback((data, token) => {
    setState({
      loading: true,
      error: false,
      message: "",
      success: false,
    });
    RankingAddCampana(data, token).then((response) => {
      setState({
        loading: false,
        error: false,
        message: "Busqueda realizada con exito",
        success: true,
      });
      setPosicion(response);
    });
  }, []);

  return {
    loading: State.loading,
    error: State.error,
    message: State.message,
    success: State.success,
    successs: State.successs,
    Posicion,
    Posiciones,
    Lugar,
    Lugares,
    Seccion,
    RankingGetService,
    SeccionGetService,
    SeccionesGetService,
    RankingAddService,
    RankingAddCampanaService,
    RankingCampanaGetGetService,
  };
}
